(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbLocalizationLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbLocalizationLib"] = factory();
	else
		root["sbLocalizationLib"] = factory();
})(window, function() {
return 